<template>
    <div>
        <div class="bg-dark m-b-30">
            <div class="container">
                <div class="row p-b-60 p-t-60">

                    <div class="col-md-6 text-white p-b-30">
                        <div class="media">
                            <div class="avatar avatar mr-3">
                                <div class="avatar-title bg-success rounded-circle mdi mdi-currency-usd  "></div>
                            </div>
                            <div class="media-body">
                                <h4 class="p-t-10">{{ pageTitle }} </h4>
                                <p class="opacity-75">
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 text-center m-b-30 ml-auto">
                        <div class="text-md-right">
                            <router-link v-can="'payroll.read'" :to="{name: 'salaries'}" class="el-button el-button--primary el-button--medium"><i
                                    class="mdi mdi-format-list-bulleted"></i> {{ $t('salary.button.salaries') }}
                            </router-link>
                            <router-link v-can="'payroll.create'" :to="{name: 'pay-salary'}" class="el-button el-button--success el-button--medium"><i
                                    class="mdi mdi-plus"></i> {{ $t('salary.button.create') }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <transition name="slide-fade">
            <router-view @parent-title="updateTitle"/>
        </transition>
    </div>
</template>

<script>
export default {
  name: 'Salary',
  data () {
    return {
      pageTitle: ''
    }
  },
  methods: {
    updateTitle (title) {
      this.pageTitle = title
    }
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
